<template>
  <v-container fluid class="px-0 py-0">
    <CommonDetail
        :height="height"
        :uid-item="uidItem"
        :store-name="storeName"
        :dto-detail-query="dtoDetailQuery"
        :dto-save-command="dtoSaveCommand"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :main-validator="mainValidator"
        :modal-dialog="modalDialog"
        :parent-component="parentComponent"
        :wrap-component="$options.name"
        @close="$emit('close')"
        @alternate_action="onAlternateAction($event)"
    >
      <template v-slot:action>
        <slot name="action"></slot>
      </template>
      <template v-slot:body>
        <slot name="body" :storeAggregate="storeAggregate" :storeDetail="storeDetail">
          <v-sheet
              v-if="!!currentItem"
              class="px-3 py-3"
          >
            <BaseFieldString
                v-model="currentItem.delivery_number"
                :label="$t('delivery_number')"
                class="mt-3"
            ></BaseFieldString>
            <CommonSelectFromTable
                v-model="currentItem.provider_uid"
                dto-list-query="ProviderListQueryDTO"
                store-name="SelectProvider"
                :sort-by="['name']"
                :label="$t('provider')"
                item-text="name"
                class="mt-6"
            >
            </CommonSelectFromTable>
            <v-row dense no-gutters>
              <v-col cols="1">
                <v-btn
                    @click="currentItem.material_owner_uid = '12796e7e-7fa2-41f1-b3de-5f112117b93d'"
                >
                  {{ $t('set_ke') }}
                </v-btn>
              </v-col>
              <v-col cols="2" v-if="!!currentItem.customer_order_uid">
                <v-btn
                    @click="currentItem.material_owner_uid = storeAggregate.rootData[currentItem.customer_order_uid].customer_uid"
                >
                  {{ $t('set_customer_order_client') }}
                </v-btn>
              </v-col>
              <v-col>
                <CommonSelectFromTable
                    v-model="currentItem.material_owner_uid"
                    dto-list-query="MaterialOwnerListQueryDTO"
                    store-name="SelectMaterialOwner"
                    :sort-by="['name']"
                    :label="$t('material_owner')"
                    item-text="name"
                    :readonly="!!currentItem.customer_order_uid"
                >
                </CommonSelectFromTable>
              </v-col>
            </v-row>
            <v-row dense no-gutters>
              <v-col cols="1">
                <v-btn
                    @click="currentItem.usage_restriction_uid = '12796e7e-7fa2-41f1-b3de-5f112117b93d'"
                >
                  {{ $t('set_ke') }}
                </v-btn>
              </v-col>
              <v-col cols="2" v-if="!!currentItem.customer_order_uid">
                <v-btn
                    @click="currentItem.usage_restriction_uid = storeAggregate.rootData[currentItem.customer_order_uid].customer_uid"
                >
                  {{ $t('set_customer_order_client') }}
                </v-btn>
              </v-col>
              <v-col>
                <CommonSelectFromTable
                    v-model="currentItem.usage_restriction_uid"
                    dto-list-query="MaterialOwnerListQueryDTO"
                    store-name="SelectMaterialOwner"
                    :sort-by="['name']"
                    :label="$t('usage_restriction')"
                    item-text="name"
                    :readonly="!!currentItem.customer_order_uid"
                >
                </CommonSelectFromTable>
              </v-col>
            </v-row>
<!--            <v-row dense no-gutters>-->
<!--                <CommonSelectFromTable-->
<!--                    v-model="currentItem.usage_restriction_uid"-->
<!--                    dto-list-query="MaterialOwnerListQueryDTO"-->
<!--                    store-name="SelectUsageRestriction"-->
<!--                    :sort-by="['name']"-->
<!--                    :label="$t('usage_restriction')"-->
<!--                    item-text="name"-->
<!--                    :readonly="!!currentItem.customer_order_uid"-->
<!--                >-->
<!--                </CommonSelectFromTable>-->
<!--            </v-row>-->
            <v-checkbox
                v-model="currentItem.mandatory_pn"
                :label="$t('mandatory_pn')"
                class="mt-3">
            </v-checkbox>
            <v-checkbox
                v-model="currentItem.opened"
                :label="$t('material_delivery_opened')"
                class="mt-3">
            </v-checkbox>
            <v-row>
              <v-col cols="6">
                <v-textarea v-model="data.part_number_list" label="P/N list" rows="10" dense outlined></v-textarea>
              </v-col>
              <v-col cols="6">
                <v-textarea v-model="data.part_number_quantity_list" label="Result list" rows="10" dense outlined></v-textarea>
              </v-col>
            </v-row>
          </v-sheet>
        </slot>
      </template>
    </CommonDetail>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useDetailStore} from "@/components/Common/CommonDetail";
import {useTableStore} from "@/components/Common/CommonTable"
import CommonDetail from "@/components/Common/CommonDetail";
import BaseFieldString from "@/components/Base/BaseFieldString";
import CommonSelectFromTable from "@/components/Common/CommonSelectFromTable";
import BaseFieldText from "@/components/Base/BaseFieldText";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";
import BaseFieldSelect from "@/components/Base/BaseFieldSelect";
import {v4 as uuidv4} from "uuid";
import {useStepperStore} from "@/components/Common/CommonStepper";

export default {
  name: "MaterialDeliveryDetail",

  props: {
    height: {default: null},
    uidItem: {default: null},
    storeName: {type: [String], default: 'MaterialDeliveryDetail'},
    dtoDetailQuery: {default: 'MaterialDeliveryDetailQueryDTO'},
    dtoActionCommand: {type: [String], default: 'MaterialDeliveryActionCommandDTO'},
    dtoSaveCommand: {type: [String], default: 'MaterialDeliverySaveCommandDTO'},
    dtoValidateCommand: {type: [String], default: 'MaterialDeliveryValidateCommandDTO'},
    dtoModelForValidate: {type: [String], default: 'MaterialDeliveryDTO'},
    mainValidator: {type: [Boolean], default: true},
    modalDialog: {type: [Boolean], default: false},
    parentComponent: {type: [String], default: 'MaterialDeliveryTable'},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    BaseFieldNumber,
    BaseFieldText,
    BaseFieldString,
    CommonDetail,
    CommonSelectFromTable,
    BaseFieldSelect,
  },

  computed: {
    currentItem() {
      if (!!this.storeAggregate && this.storeAggregate.rootData && !!this.storeDetail && !!this.storeDetail.uidItem)
        return this.storeAggregate.rootData[this.storeDetail.uidItem]
      else
        return null
    },
  },

  methods: {
    onAlternateAction(event) {
      console.log('onAlternateAction')
      if (event.actionName === 'alternate_aggregate_by_part_number' || event.actionName === 'alternate_download_part_number') {
        this.data.material_delivery_uid = this.storeDetail.uidItem
        this.storeDetail.onAction({actionName: event.actionName, actionUid: event.actionUid,
          data:  this.data, callReceive: this.onReceiveAggregate})
      }
    },
    onReceiveAggregate(data) {
      this.data = data.action_state.action_results.data
    },
  }
  ,

  mounted() {
    this.storeDetail = useDetailStore(this.storeName)()
    this.storeAggregate = useAggregateStore()
    // this.storeSelectMaterialSupplier = useTableStore('SelectMaterialSupplier')()

    this.storeStepper = useStepperStore('MaterialDeliveryStepper')()
    this.storeStepper.dtoActionCommand = 'MaterialDeliveryActionCommandDTO'
    // console.log('storeSelectMaterialSupplier', this.storeSelectMaterialSupplier)
  }
  ,

  data() {
    return {
      storeDetail: null,
      storeAggregate: null,
      storeSelectMaterialDelivery: null,
      storeStepper: null,
      data: {
        part_number_list: null,
        part_number_quantity_list: null,
        material_delivery_uid: null,
      },
      customer_order_query_filters: {
        and_concat: true,
        filter_list: [
          {param_compare: 'productorder__bomsheet__isnull', value: false},
        ],
        enable: true,
      },
    }
  }
  ,
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreMaterial/locales.json">
</i18n>